import { api } from './NetworkUtility';
import { logError } from './ErrorService';

// let getFeatureFlagsAbortController = new AbortController();

/*
    This method will retrieve Feature Flags for the current customer.

    Included in the flags are the messages used by NotificationBanner
*/
export const getFeatureFlags = async (companyNumber, callbackHandler, callbackErrorHandler) => {
    if (companyNumber == null || typeof companyNumber === 'undefined') {
        return;
    }

    // Abort any preivous calls before retrieving new feature flags
    // getFeatureFlagsAbortController.abort();
    // getFeatureFlagsAbortController = new AbortController(); 

    const url = `/featureflags/companies/${companyNumber}`;
    return api.get(url)
        .then((response) =>
            callbackHandler(response.data)
        )
        .catch(function (error) {
            if (error?.response?.status === 401 || error?.response?.status === 403) {
                //unauthorized user - log unauth attempt and redirect
                logError("Unauthorized user attempt", () => {
                    window.location = "/unauthorizedUser?ff";
                });
            } else {
                callbackErrorHandler(error);
            }
        });
}